var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"id":"dashboard","infinite-scroll-handler":_vm.handleInfiniteScroll}},[_c('dashboard-scans',{ref:"dashboardScans"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }